import React, { useLayoutEffect, useState } from "react";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import loadTicketsArray from "../../shared/functions/loadTicketsArray";
import TicketsSideBar from "../components/Sidebar/TicketsSideBar";
import TicketsSideBarMobileChecker from "../components/Sidebar/TicketsSideBarMobileChecker";
import Informer from "../../shared/components/Informer/Informer";
import Switcher from "../../shared/components/Switcher/Switcher";
import NotFound from "../../errorPages/NotFound";
import { useHistory } from "react-router-dom";
import Loader from "../../shared/components/Loader";
import ErrorLoadData from "../../errorPages/ErrorLoadData";

import { trainingAndThemeModeLinkSwitch } from "../../shared/functions/trainingAndThemeModeLinkSwitch";
/* import { ticketsVideoData } from "../../shared/ticketsVideoData";
import TicketVideoComponent from "../components/TicketVideoComponent"; */

import VideoSectionRandom from "../../video-section/VideoSectionRandom";

/* import VkComments from "../../shared/components/VkComments"; */

import Ticket from "../components/Ticket";
import "../../App.css";

const TrainingMode = (props) => {
  const history = useHistory();

  const [isDataRecived, setIsDataRecived] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);


  let ticketStatusArray = JSON.parse(localStorage.getItem("ticketStatusArray"));

  useLayoutEffect(() => {

    const myfunc = async () => {
      if (props.ticketsArray.length === 0) {
        try {
          setLoading(true);
          const loadTickets = await loadTicketsArray(props.categoryTickets);
          setIsDataRecived(true);
          props.setTicketsArray(loadTickets);
          props.setLoadedBilet(loadTickets[props.paramsTicketId - 1]);
          setLoading(false);
        }
        catch (error) {
          setError(true);
          setLoading(false);
          setIsDataRecived(false);
        }
      }
    }

    if (props.ticketsArray.length === 0 && !error) {
      myfunc();
    }

  }, [props, loading, error]);

  const onSwitchThemeChange = () => {
    const link = trainingAndThemeModeLinkSwitch(ticketStatusArray, "themeAB")
    history.push(link);
    props.setTicketsArray([]);
    props.setLoadedBilet(null);
    if (props.numbersStateArray.length !== 0) props.resetNumbersStateArray();
  }

  if (!props.loadedBilet) {
    const biletId = parseInt(props.paramsTicketId);
    if (!biletId || biletId > 40 || biletId < 1) {
      return (<NotFound />)
    }
  }

  /* props.ticketsArray.length === 0 || !props.loadedBilet  */

  return (
    <>
      {error && <ErrorLoadData />}
      {loading && <Loader loadingTickets={true} />}
      {isDataRecived && props.loadedBilet && <div className="grid-container">
        <div className="dash-board">
          <Ticket
            currentTicket={props.loadedBilet}
            ticketsArray={props.ticketsArray}
            categoryTickets={props.categoryTickets}
          />
          <div className="adblock-after-task">
            <div id="yandex_rtb_R-A-1691059-3"></div>
            <script>{window.yaContextCb.push(() => {
              window.Ya.Context.AdvManager.render({
                renderTo: 'yandex_rtb_R-A-1691059-3',
                blockId: 'R-A-1691059-3'
              })
            })}</script>
          </div>

          {/*    <div className="adblock-after-task-only-mobile">
            <div id="yandex_rtb_R-A-1691059-2"></div>
            <script>{window.yaContextCb.push(() => {
              window.Ya.Context.AdvManager.render({
                renderTo: 'yandex_rtb_R-A-1691059-2',
                blockId: 'R-A-1691059-2'
              })
            })}</script>
          </div> */}

        </div>

        <div className="side-bar">
          <TicketsSideBarMobileChecker he={props.loadedBilet.header}>
            {(params) =>
              params ? (
                <>
                  {props.ticketsArray !== undefined && props.categoryTickets === "ticketsAB" &&
                    <Switcher
                      header="Вопросы по темам"
                      checked={false}
                      onChangeHandler={onSwitchThemeChange}
                    />
                  }

                  <TicketsSideBar
                    ticketsArray={props.ticketsArray}
                    categoryTickets={props.categoryTickets}
                    closeSideBarMobile={params.closeDrawerHandler}
                  />
                </>

              ) : (
                <div className="side-bar">
                  {props.ticketsArray !== undefined && props.categoryTickets === "ticketsAB" &&
                    <Switcher
                      header="Вопросы по темам"
                      checked={false}
                      onChangeHandler={onSwitchThemeChange}
                    />
                  }
                  <TicketsSideBar
                    ticketsArray={props.ticketsArray}
                    categoryTickets={props.categoryTickets}
                  />
                  <div style={{ maxHeight: "510px" }} className="my-2">
                    <div id="yandex_rtb_R-A-1691059-5"></div>
                    <script>{window.yaContextCb.push(() => {
                      window.Ya.Context.AdvManager.render({
                        renderTo: 'yandex_rtb_R-A-1691059-5',
                        blockId: 'R-A-1691059-5'
                      })
                    })}</script>
                  </div>
                  <Informer />
                </div>
              )
            }
          </TicketsSideBarMobileChecker>
        </div>

        <div className="video-section-main-page" style={{ marginTop: "2rem" }}>
          <VideoSectionRandom limitForShow={9} />
        </div>
      </div>
      }

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    ticketsArray: state.ticketsReducer.ticketsArray,
    loadedBilet: state.ticketsReducer.loadedBilet,
    themeMode: state.ticketsReducer.themeMode,
    categoryTickets: state.router.location.pathname.split("/")[1],
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({
        type: actionTypes.RESET_NUMBERS_STATE_ARRAY,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    debugSET_NUMBERS: (obj) =>
      dispatch({
        type: "SET_NUMBERS_STATE_ARRAY",
        arrayItem: {
          id: obj.id,
          isError: obj.isError,
          clickedAnswer: obj.clickedAnswer,
          ticketId: obj.ticketId,
          taskId: obj.taskId,
        },
      }),
    setThemeMode: (themeMode) => {
      localStorage.setItem("themeMode", themeMode);
      dispatch({
        type: "SET_THEME_MODE",
        themeMode: themeMode,
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingMode);


/*  CODE BELOW FOR DEBUG ONLY */
/*    useEffect(() => {
  let obj;
  for (let index = 0; index < 20; index++) {
    obj = {
      id: index + 1,
      isError: true,
      clickedAnswer: 1,
      ticketId: "1",
      taskId: "1",
    };
    props.debugSET_NUMBERS(obj);
  }
}, []); */